export default __webpack_public_path__ + "static/media/Summan-Dental-Clinic.fae2c136.png";